import ACTION_TYPES from "../actions/actionTypes";

export default (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.FETCH_OPH_LIST_BY_TIER:
      return { ...state, ophList: action.payload };
    case ACTION_TYPES.FETCH_OPH_BY_ID:
      return { ...state, ophDetails: action.payload };
    case ACTION_TYPES.UPDATE_OPH_STATUS:
      return { ...state, status: action.payload };
    case ACTION_TYPES.FETCH_OPH_DETAILS:
      return { ...state, ophValue: action.payload };
    case "FETCH_COLORS":
      return { ...state, colorCodes: action.payload };
    case ACTION_TYPES.FETCH_SHIFTSCHEDULE:
      return { ...state, shiftData: action.payload };
    case "FETCH_MATERIALS":
      return { ...state, materialList: action.payload };
    case "FETCH_LEVEL0":
      return { ...state, level0List: action.payload };
    case "FETCH_LEVEL1":
      return { ...state, level1List: action.payload };
    case "FETCH_LEVEL2":
      return { ...state, level2List: action.payload };
    case "FETCH_OPH_TAKT_INFO":
      return { ...state, ophTaktInfo: action.payload };
    case "FETCH_OPH_TAKT_DATA":
      return { ...state, ophTaktdata: action.payload };
    case ACTION_TYPES.FETCH_OPH_MISS_REASON_GRAPH:
      return { ...state, ophMissReasonGraph: action.payload };
    case ACTION_TYPES.FETCH_OPH_ATTAINMENT_GRAPH:
      return { ...state, ophAttainmentGraph: action.payload };
    default:
      return state;
  }
};
